import { get } from 'svelte/store';
import { dictionary } from './currentDictionary.service';
function pathComponentEncoder(value) {
    /*value = value.replace("%", "%25");
    value = value.replace("/", "%252F"); // Spring problem
    value = value.replace("\\", "%255C"); // Spring problem
    value = value.replace("&", "%26"); // Chrome problem (check & and &amp
    // in links, are seen as same)
*/
    value = encodeURIComponent(value);
    value = value.replace("%5C", "%255C");
    value = value.replace("%2F", "%252F");
    value = value.replace("%40", "@");
    value = value.replace("%24", "$");
    value = value.replace("(", "%28");
    value = value.replace(")", "%29");
    if (value.length > 0 && value.charAt(0) === '.') {
        value = "%252E" + value.substring(1);
    }
    return value;
}
const glosbeGlobalState = window.glosbe || { dictionary: {} };
export function generatePhraseUrlForCurrentDictionary(phrase, reverse) {
    var _a, _b;
    const dictionaryData = get(dictionary);
    let l1 = dictionaryData.l1;
    let l2 = dictionaryData.l2;
    if (reverse) {
        l1 = dictionaryData.l2;
        l2 = dictionaryData.l1;
    }
    let url = '/' + [l1.code, l2.code, phrase].map(part => pathComponentEncoder(part.trim())).join("/");
    const pageStateDictionary = glosbeGlobalState.dictionary;
    if (((_a = pageStateDictionary === null || pageStateDictionary === void 0 ? void 0 : pageStateDictionary.l1) === null || _a === void 0 ? void 0 : _a.code) === l1.code && ((_b = pageStateDictionary === null || pageStateDictionary === void 0 ? void 0 : pageStateDictionary.l2) === null || _b === void 0 ? void 0 : _b.code) === l2.code && glosbeGlobalState.translationUrlTemplate) {
        let phraseComponent = "";
        if (phrase && phrase.trim().length > 0) {
            phraseComponent = `/${pathComponentEncoder(phrase.trim())}`;
        }
        url = glosbeGlobalState.translationUrlTemplate.replace("/PHRASE_PLACEHOLDER", phraseComponent);
    }
    return url;
}
export function generatePhraseUrlForAnyDictionary({ phrase, l1, l2 }) {
    let url = '/' + [l1, l2, phrase].map(part => pathComponentEncoder(part.trim())).join("/");
    return url;
}
